"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const common_1 = require("@Const/common");
const react_router_dom_1 = require("react-router-dom");
const HttpError_1 = require("@App/exceptions/HttpError");
require("./index.scss");
const navigation_1 = __importDefault(require("@App/navigation"));
const RootErrorBoundary = () => {
    let title = 'Something went wrong with this page...';
    const error = (0, react_router_dom_1.useRouteError)();
    const isError = error instanceof Error;
    if (isError) {
        if ((0, HttpError_1.isHttpError)(error)) {
            if (error.statusCode === '503' || error.statusCode === 503) {
                title = "We're undergoing maintenance.";
            }
        }
    }
    return (react_1.default.createElement("div", { className: 'root-error-boundary' },
        react_1.default.createElement("nav", { className: "navigation-bar-component", "data-testid": "navigation-bar-component" },
            react_1.default.createElement("div", { className: "accounting-block" },
                react_1.default.createElement(react_router_dom_1.NavLink, { to: navigation_1.default.login.root(), className: "logo-link" },
                    react_1.default.createElement("img", { src: common_1.ICONS.mlc_logo_black, alt: "MLC Logo" }))),
            react_1.default.createElement("div", { className: "right-block" })),
        react_1.default.createElement("div", { className: "global-container" },
            react_1.default.createElement("div", { className: "error-holder" },
                react_1.default.createElement("h1", null, title),
                react_1.default.createElement("pre", null, isError ? error.message : JSON.stringify(error)),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("a", { href: "/" }, "Click here to go back home.")),
                react_1.default.createElement("p", { style: { marginTop: '24px', marginBottom: '24px' } },
                    "If the problem persists, please contact our CX team at",
                    ' ',
                    react_1.default.createElement("a", { href: 'mailto:support@themlc.com' }, "support@themlc.com"))))));
};
exports.default = RootErrorBoundary;
